import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { of } from 'rxjs';
import { RoleApiService } from '../../../services/role-api.service';
import { RoleResponse } from '../../../types/role.types';

export const roleResolver: ResolveFn<RoleResponse | null> = (route) => {
  let id = route.paramMap.get('id');

  if (!id) {
    return of(null);
  }

  return inject(RoleApiService).getRole(Number(id));
};
